webpackJsonp([245625440600917],{

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CamazonAffiliatePageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _layout = __webpack_require__(22);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _structuredData = __webpack_require__(28);
	
	var _structuredData2 = _interopRequireDefault(_structuredData);
	
	var _seoTags = __webpack_require__(27);
	
	var _seoTags2 = _interopRequireDefault(_seoTags);
	
	var _reactRouterDom = __webpack_require__(23);
	
	var _breadcrumbs = __webpack_require__(45);
	
	var _breadcrumbs2 = _interopRequireDefault(_breadcrumbs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AmazonAffiliatePage = function AmazonAffiliatePage(_ref) {
	  var data = _ref.data,
	      location = _ref.location;
	  var post = data.markdownRemark;
	
	  var title = post.frontmatter.title;
	  var seo = post.frontmatter.seo;
	  var html = post.html;
	
	  return _react2.default.createElement(
	    _layout2.default,
	    null,
	    _react2.default.createElement(_structuredData2.default, { isReview: false, isBreadcrumbs: true, title: title, pagePath: location.pathname }),
	    _react2.default.createElement(_seoTags2.default, {
	      title: '' + seo.title,
	      description: '' + seo.description
	    }),
	    _react2.default.createElement(_breadcrumbs2.default, { currentPage: title }),
	    _react2.default.createElement(
	      'div',
	      { className: 'amazon-affiliate' },
	      _react2.default.createElement(
	        'div',
	        { className: 'amazon-affiliate__wrapper' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'amazon-affiliate__title', id: title },
	          title
	        ),
	        _react2.default.createElement('div', { className: 'amazon-affiliate__text', dangerouslySetInnerHTML: { __html: html } })
	      )
	    )
	  );
	};
	
	AmazonAffiliatePage.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactRouterDom.withRouter)(AmazonAffiliatePage);
	var CamazonAffiliatePageQuery = exports.CamazonAffiliatePageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-amazon-affiliate-js-cfad03e2f19f863eb806.js